import React, { useEffect, useState } from "react";
import { Input, Space, Form, Button, message, Modal, notification } from "antd";
import { AiOutlineRight } from "react-icons/ai";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import { GrUpload } from "react-icons/gr";


import {
  Image,
  Select,
  TimePicker,
  Upload,
} from "antd";
import bannerRequest from "./webTestimonialRequest";
import webTestimonialRequest from "./webTestimonialRequest";
const initialFilter = { page: 1, limit: 10 };

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });


function WebTestimonialUpdate() {

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const navigate = useNavigate()
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [videoList, setVideoList] = useState([]);
  const [labList, setLabList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [filter, setFilter] = useState(initialFilter);
  const [pathType, setPathType] = useState(''); // Store selected pathType
  const [pathIdOptions, setPathIdOptions] = useState([]); // Store fetched pathId options
  const [options, setOptions] = useState([]); // Options for select
  const { id } = useParams();
  const { Option } = Select;
  const [bannerDetails, setBannerDetails] = useState({});
  const [submited, setSubmit] = useState(false);



  useEffect(() => {
    console.log("bannerId:", id);
    const getBannerDetails = async () => {
      setLoading(true);

      try {

        const res = await webTestimonialRequest.gettesTimonialDetail(id);
        console.log("API response:", res);

        const bannerData = res?.data?.data;
        console.log(bannerData, 'bannerData')

        if (bannerData) {
          const mappedData = {
            ...bannerData,

            status: bannerData?.status === 1 ? "1" : "0",


          }
          setBannerDetails(mappedData)
          console.log("mappedData", mappedData);
      
          if (mappedData.imageUrl) {
            setFileList([{ url: mappedData.imageUrl, name: "Uploaded Image" }]);
          }
          form.setFieldsValue(mappedData);
        }

      } catch (e) {
        console.log(e);
      } finally {
        setLoading(false);
      }
    };

    if (id) getBannerDetails();
  }, [id, form]);

const update=()=>{
  setSubmit(true);
}

  const onFinish = (values) => {
    console.log("Form values:", values);
    console.log("first",submited)
    if(submited){
      setLoading(true);
      const formData = { ...values, id : id };
  
      webTestimonialRequest.postUpdaTetestimonial(formData)
        .then((res) => {
          if (res.status === 200) {
            notification["success"]({
              message: "Testimonial updated successfully",
            });
            navigate(-1, { state: { refresh: true } });
          } else {
            notification["error"]({
              message: "Something went wrong",
            });
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
          notification["error"]({
            message: "Failed",
          });
        });
    }
   
  };


  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const handleImageChange = ({ fileList: newFileList }) =>{
    setFileList(newFileList);
  if (newFileList.length > 0) {

    const newFile = newFileList[0];
    setPreviewImage(newFile.url || newFile.preview);
  } else {
    setPreviewImage("");
  }
}
  const uploadButton = (
    <button
      style={{
        border: 0,
        background: "none",
      }}
    >
      <GrUpload />
      <div
        style={{
          marginTop: 8,
        }}
      >
        Upload
      </div>
    </button>
  );

  const handleChange = (value) => {
    console.log(`selected ${value}`);
  };

  const imageUpload = (file, name) => {
    setLoading(true);

    const modifiedFile = new File([file], name, { type: file.type });
    let formData = new FormData();
    formData.append("file", modifiedFile);
    formData.append("fileName", name);
    bannerRequest
      .uploadImage(formData)
      .then((res) => {
        setLoading(false);
        form.setFieldsValue({
          imageUrl: res?.data?.uploadDirectory,

        });
        console.log(res)
        if (res) {
          return true;
        } else {
          return false;
        }
      })
      .catch((e) => {
        setLoading(false);
        notification["error"]({
          message: "File upload Failed",
        })
      }
      );
  };

  // const props = {
  //   name: "file",
  //   multiple: false,
  //   beforeUpload: (file) => {

  //     imageUpload(file, file.name);
  //     return false;
  //   },
  //   onRemove() {
  //     setFileList([]);
  //   },
  // };

    const props = {
      name: "file",
      multiple: false,
      accept : "image/*",
      beforeUpload: (file) => {
        const isImage = file.type.startsWith("image/");
        if(!isImage){
          notification.error({
            message : "Invalid file type",
            description : "Only image files are allowed (jpg, png, jpeg, webp)",
          });
          return Upload.LIST_IGNORE; 
        }
        imageUpload(file, file.name);
        return false;
      },
      onRemove() {
        setFileList([]);
      },
    };
  return (
    <div>
         <section>
           <div className="Create-Category">
             <Form.Item className=" submit-btn">
               <Space>
                 <Button className="f-sub-btn btn-width" onClick={() => navigate(-1)} disabled={loading}>
                   <ArrowLeftOutlined />
                 </Button>
               </Space>
             </Form.Item>
             <h3>Update Website Testimonials</h3>
   
   
             <Form
               layout="vertical"
               className="subscription-form"
               form={form}
               onFinish={onFinish}
             >
               <div className="subscription">
                 <Form.Item
                   label="Name"
                   name="name"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please enter  name" },
                     {
                       pattern: /^[A-Za-z\s]+$/,
                       message: "Name can only contain alphabetic characters!",
                     },
                   ]}
                 >
                   <Input size="large" placeholder="Enter Name" />
                 </Form.Item>
   
                 <Form.Item
                   label="Status"
                   name="status"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please select status" },
                   ]}
                 >
                   <Select
                     placeholder="Select status"
                     // style={{
                     //   marginTop: "0.5rem",
   
                     //   width: "99%",
                     // }}
                     onChange={handleChange}
                     options={[
                       {
                         value: "0",
                         label: "Inactive",
                       },
                       {
                         value: "1",
                         label: "Active",
                       },
   
                     ]}
                   />
                 </Form.Item>
               </div>
   
               <div className="subscription">
                 <Form.Item
                   label="Designation"
                   name="designation"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please enter designation" },
                     {
                       pattern: /^[A-Za-z0-9\s\-/,()]+$/,
                       message: "Invalid designation format",
                     },
                     {
                       min: 2,
                       message: "Designation must be at least 2 characters",
                     },
                     {
                       max: 50,
                       message: "Designation cannot exceed 50 characters",
                     },
                   ]}
                 >
                   <Input size="large" placeholder="Enter designation" />
                 </Form.Item>
                   <Form.Item
                   label="Rating"
                   name="rating"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please enter message" },
                     {
                       type: "number",
                       min: 1,
                       max: 5,
                        transform: (value) => Number(value),
                       message: "Rating must be between 1 and 5",
   
                     },
                   ]}
                 >
                   <Input size="large" placeholder="Enter message" />
                 </Form.Item>
               
               </div>
   
   
               <div className="subscription">
               
   
                 <Form.Item
                   label="Order By"
                   name="orderBy"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please select order" },
                   ]}
                 >
                   <Select
                     placeholder="Select order"
   
                     onChange={handleChange}
                     options={[
                       {
                         value: "1",
                         label: "1",
                       },
                       {
                         value: "2",
                         label: "2",
                       },
                       {
                         value: "3",
                         label: "3",
                       },
                       {
                         value: "4",
                         label: "4",
                       },
                       {
                         value: "5",
                         label: "5",
                       },
   
                     ]}
                   />
                 </Form.Item>
   
                   <Form.Item
                   label="Message"
                   name="message"
                   className="subscription-plan"
                   rules={[
                     { required: true, message: "Please enter message" },
                     {
                       min: 10,
                       message: "Message must be at least 10 characters",
                     },
                     {
                       max: 300,
                       message: "Message cannot exceed 300 characters",
                     },
                     {
                       validator: (_, value) => {
                         if (!value || value.trim() === "") {
                           return Promise.reject("Message cannot be empty or spaces only");
                         }
                         return Promise.resolve();
                       },
                     },
                   ]}
                 >
                   <Input.TextArea
                     size="large"
                     placeholder="Enter message"
                     rows={4}
                   />
                 </Form.Item>
   
               </div>
   
   
               {/* <div className="upload-Img">
                 <Form.Item
                   label="Upload Service image"
                   name="imageUrl"
                   rules={[{ required: true, message: "Please upload the Image" }]}
                 >
                   <Upload
                     {...props}
                     maxCount={1}
                     listType="picture-card"
                     fileList={fileList}
                     onPreview={handlePreview}
                     onChange={handleImageChange}
                   >
                     {fileList.length >= 1 ? null : uploadButton}
                   </Upload>
                 </Form.Item>
               </div> */}
               <div className="upload-Img">
                 <Form.Item
                   label="Upload Customer Images"
                   name="imageUrl"
   
                   rules={[
                     {
                       required: true,
                       message: "Please upload the customer images",
                     },
                   ]}
                 >
                   <Upload
                     {...props} maxCount={1}
                     listType="picture-card"
                     fileList={fileList}
                     onPreview={handlePreview}
                     onChange={handleImageChange}
                   >
                     {fileList.length >= 1 ? null : uploadButton}
                   </Upload>
                   {previewImage && (
                     <Image
                       wrapperStyle={{
                         display: "none",
                       }}
                       preview={{
                         visible: previewOpen,
                         onVisibleChange: (visible) => setPreviewOpen(visible),
                         afterOpenChange: (visible) =>
                           !visible && setPreviewImage(""),
                       }}
                       src={previewImage}
                     />
                   )}
                 </Form.Item>
               </div>
   
   
   
               <div className="bottom-button">
                 <div style={{ padding: "10px" }}>
                   <Button type="primary" htmlType="submit" loading={loading} onClick={update}>
                     Save & Proceed
                     <span>
                       <AiOutlineRight />
                     </span>
                   </Button>
                 </div>
               </div>
   
             </Form>
           </div>
         </section>
       </div>
  )
}
export default WebTestimonialUpdate